import axios from 'axios';
import { API_BASE_URL } from '../config';

// Create axios instance with proper configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Increased timeout for better handling
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    // "Auth-Key": "z5NaBscERcF3hyl+TykKbBZGLveOWzcwlJFIEHAVjKQ=" // Placeholder, will be set in interceptor
  },
  withCredentials: false, // Important for CORS
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const authKey = localStorage.getItem('authKey');

    // Only add auth header if it exists and is valid
    if (authKey && authKey !== "undefined" && authKey !== "null" && authKey !== "") {
      config.headers['auth-key'] = authKey;
    }

    console.log(`🚀 Making ${config.method?.toUpperCase()} request to:`, config.url);
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response Success:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('❌ API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      code: error.code
    });

    // Enhanced error handling
    if (error.code === 'ERR_NETWORK') {
      console.error('🌐 Network Error - Check:', {
        'CORS Issue': 'Backend might not have CORS enabled',
        'URL Accessibility': 'Verify the API endpoint is accessible',
        'Internet Connection': 'Check your network connection'
      });
    }

    if (error.response) {
      // Server responded with error status
      console.error('📊 Server Error Details:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      // Request was made but no response received
      console.error('📡 No Response Received:', error.request);
    }

    return Promise.reject(error);
  }
);

export default api;